import React, {useState, useEffect} from 'react'
import PropTypes from 'prop-types'
import {Input, Radio} from "antd"

RadioMultiInput.propTypes = {
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.any
}

function RadioMultiInput(props) {
    const {value} = props
    const [type, setType] = useState(!!value ? (value.hasOwnProperty('lte') && value.hasOwnProperty('gte')) ? 'range' : (value.lte > 0 ? 'lte' : 'gte') : '')
    const [inputValue, setInputValue] = useState(value ? (type === 'lte' ? value.lte : value.gte) : '')
    const [inputValueRange, setInputValueRange] = useState(value ? (type === 'range' ? {from: value.gte, to: value.lte} : {from: '', to: ''}) : '')

    function _onChange(e) {
        const {onChange} = props
        const {value} = e.target

        setType(value)
        setInputValue('')
        setInputValueRange({from: '', to: ''})

        if (typeof onChange === 'function') {
            if (value !== '') {
                if(value === 'range'){
                    onChange(value, {from: '', to: ''})
                }else{
                    onChange(value, '')
                }
            } else {
                onChange('default', '')
            }
        }
    }

    function _handleChange(e) {
        const {value} = e.target

        setInputValue(value)
    }

    function _handleChangeRange(e) {
        const {name,value} = e.target
        const getValueRange = Object.assign({}, inputValueRange, {[name]: value})

        setInputValueRange(getValueRange)
    }

    useEffect(() => {
        const {onChange} = props

        setTimeout(() => {
            if (typeof onChange === 'function') {
                if(type === 'range'){
                    onChange(type, inputValueRange)
                }else{
                    onChange(type, inputValue)
                }
            }
        }, 500)
        // eslint-disable-next-line
    }, [type, inputValue, inputValueRange])

    const {label, validate} = props
    const {from, to} = inputValueRange

    return (
        <div className="RadioMultiInput">
            <label htmlFor="">{label} <span className='Required'>*</span></label>
            <Radio.Group onChange={_onChange} value={type}>
                <Radio value=''>All</Radio>
                <Radio value='lte'>Less than or equal: <Input disabled={type !== 'lte'} name='lte'
                                                              value={type === 'lte' ? inputValue : ''}
                                                              type="text" onChange={_handleChange}/>
                </Radio>
                <Radio value='gte'>Greater than: <Input disabled={type !== 'gte'}
                                                        value={type === 'gte' ? inputValue : ''}
                                                        name='gte' type="text" onChange={_handleChange}/>
                </Radio>
                <Radio value='range'>Greater than: <Input disabled={type !== 'range'}
                                                        value={type === 'range' ? from : ''}
                                                        name='from' type="text" onChange={_handleChangeRange}/>
                    And Less than or equal: <Input disabled={type !== 'range'} name='to'
                                               value={type === 'range' ? to : ''}
                                               type="text" onChange={_handleChangeRange}/>
                </Radio>
            </Radio.Group>

            {
                !!validate && validate.length > 0 && <small className="Validate">{validate}</small>
            }
        </div>
    )
}

export default RadioMultiInput